import { logUserActivity } from "./activityService";
import { userApiService } from "./userApiService";

export async function getUserProfile(uid) {
  const data = await userApiService.getProfile();
  return data?.item || null;
}

export async function saveUserProfile(uid, profile) {
  await userApiService.saveProfile({ ...profile, updatedAt: Date.now() });
  await logUserActivity(uid, {
    type: "profile_update",
    title: "Updated profile details",
    details: "Saved personal profile changes.",
  });
}

export async function upsertUserProfile(uid, partialProfile) {
  await userApiService.saveProfile({ ...partialProfile, updatedAt: Date.now() });
}

export async function removeUserProfile(uid) {
  await userApiService.deleteProfile();
  await logUserActivity(uid, {
    type: "profile_remove",
    title: "Removed profile data",
    details: "Cleared profile details from account.",
  });
}

